import React, { useState, useCallback } from 'react';
import { Play } from 'lucide-react';
import HeroVisual from './HeroVisual';
import VideoModal from './VideoModal';
import { heroData } from '../mock';

const scrollToContact = () => {
  const contactElement = document.querySelector('#contact');
  if (contactElement) {
    contactElement.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }
};

const Hero = () => {
  const [videoOpen, setVideoOpen] = useState(false);

  const handleCloseVideo = useCallback(() => setVideoOpen(false), []);

  return (
    <section className="dark-full-container hero-section" style={{ paddingTop: '100px', paddingBottom: '80px' }}>
      <div className="dark-content-container">
        <div className="hero-split">
          <div className="hero-content">
            <h1 className="hero-headline gradient-text" style={{ marginBottom: '24px' }}>
              {heroData.headline}
            </h1>

            <p className="body-large" style={{ marginBottom: '40px', maxWidth: '540px', color: 'var(--text-secondary)' }}>
              {heroData.subheadline}
            </p>

            <div className="hero-actions">
              <button
                className="btn-primary"
                onClick={scrollToContact}
              >
                Build Your First App
              </button>
              <button
                className="btn-secondary"
                type="button"
                onClick={() => setVideoOpen(true)}
                aria-haspopup="dialog"
                aria-label="Watch the QuByt AI demo video"
              >
                <Play size={18} />
                Watch Demo
              </button>
            </div>
          </div>

          <div className="hero-visual">
            <HeroVisual />
          </div>
        </div>
      </div>

      {videoOpen && (
        <VideoModal onClose={handleCloseVideo} onGetStarted={scrollToContact} />
      )}
    </section>
  );
};

export default Hero;
